
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.5 6V1.5H12m4.5 0l-10 10m2-7h-6a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1v-6","stroke":"currentColor","stroke-width":"1.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    